import { Component, Input, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Course } from '../shared/course';
import { CourseUserService } from '../shared/course-user.service';

@Component({
  selector: 'app-course-enrollment-status',
  templateUrl: './course-enrollment-status.component.html'
})
export class CourseEnrollmentStatusComponent implements OnChanges {
  @Input() course: Course;
  enrollmentObservable: Observable<any>;
  inProgressCourse: boolean;

  constructor(private service: CourseUserService) { }

  ngOnChanges() {
    if (this.course) {
      this.enrollmentObservable = this.service.readEnrollment(this.course);
      const course = Object.assign(new Course(), this.course);
      this.inProgressCourse = course.isInProgress();
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-enrollment-status/course-enrollment-status.component.ts